import { ActionsUnion, createAction } from "@redux/helpers";
import {
  StylehintListUgcResponse,
  UserProfileData,
  UserProfilePayload,
  UserProfileStyles
} from "@type/index";
import {
  UserInfoMapper,
  UserStylingListMapper
} from "@util/net/queryParameters";

export const INIT_USER_PROFILE = "[user profile] init user profile";
export const GET_USER_PROFILE = "[user profile] get user profile request";
const GET_USER_PROFILE_SUCCESS = "[user profile] get user profile success";
const GET_USER_PROFILE_LOADING = "[user profile] get user profile loading";
const SET_USER_PROFILE_NOFOUND = "[user profile] set user profile not found";

export const Actions = {
  initUserProfile: () => createAction(INIT_USER_PROFILE),
  getUserProfile: (payload: UserProfilePayload) =>
    createAction(GET_USER_PROFILE, payload),
  getUserProfileSuccess: (payload: StylehintListUgcResponse) =>
    createAction(GET_USER_PROFILE_SUCCESS, payload),
  getUserProfileLoading: (payload: boolean) =>
    createAction(GET_USER_PROFILE_LOADING, payload),
  setUserProfileNotFound: (payload: string) =>
    createAction(SET_USER_PROFILE_NOFOUND, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

export type State = UserProfileData;

const initialState = {
  pagination: {
    total: 0,
    page: 1
  },
  limit: 50,
  hasMore: false,
  errorCode: "",
  loading: true
};

export default (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case INIT_USER_PROFILE:
      return {
        ...initialState
      };
    case GET_USER_PROFILE_SUCCESS: {
      const _total = action.payload.total_result_count || 0;
      // const _count = action.payload.pagination.count || 0;
      const _page = action.payload.page || 0;
      const _size = 50;
      let _user;
      let _styles: Array<UserProfileStyles> = [];
      if (
        action.payload.content_list &&
        action.payload.content_list.length > 0
      ) {
        _user = UserInfoMapper(action.payload.content_list[0].author);
        _styles = UserStylingListMapper(action.payload.content_list);
      }
      return {
        ...state,
        userInfo: _user ? { ..._user } : undefined,
        pagination: { page: _page, total: _total },
        styles: [...(state.styles || []), ...(_styles || [])],
        hasMore: _page * _size < _total,
        errorCode: "",
        loading: false
      };
    }
    case GET_USER_PROFILE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_USER_PROFILE_NOFOUND:
      return {
        ...state,
        errorCode: action.payload,
        hasMore: false,
        loading: false
      };
    default:
      return state;
  }
};
